module.exports = __webpack_public_path__ + "img/img_08.a5b0be75.png";